import { call, put, takeEvery } from "redux-saga/effects";
import { UpdateShippingAddressFailure, UpdateShippingAddressRequest, UpdateShippingAddressSuccess } from "./UpdateShippingAddressSlice";
import UpdateBrotherPlusShippingAddressPayload from "../../../utils/MyAccount/UpdateBrotherPlusShippingAddressPayload";
import { _BROTHER_PLUS_API_ENDPOINTS, SUCCESS } from "../../../constants/AppConstants";
import { _CALLPUTAPI } from "../../../api/apiHandler";
import i18next from "i18next";

function _UPDATESHIPPINGADDRESS(payload) {
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.UPDATE_SHIPPING_ADDRESS;
    return _CALLPUTAPI(endpoint, payload)
        .then(response => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function* updateShippingAddressSaga(action) {
    try {
        const updateShippingAddressPaylaod = UpdateBrotherPlusShippingAddressPayload(action.payload);

        const response = yield call(_UPDATESHIPPINGADDRESS, updateShippingAddressPaylaod);

        if (response?.actionStatus?.toUpperCase() === SUCCESS) {
            yield put(UpdateShippingAddressSuccess(response));
        } else {
            yield put(UpdateShippingAddressFailure({
                message: i18next.t("ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")
            }));
        }
    } catch (error) {
        yield put(UpdateShippingAddressFailure(error?.message ?? 'Unknown error'));
    }
}

export default function* watchUpdateShippingAddressService() {
    yield takeEvery(UpdateShippingAddressRequest.type, updateShippingAddressSaga);
}